import { defineMessages } from "react-intl"

export default defineMessages({
  pageTitle: {
    id: "app.components.Home.pageTitle",
  },
  heading: {
    id: "app.components.Home.heading",
  },
  description: {
    id: "app.components.Home.description",
  },
  tellMeMore: {
    id: "app.components.Home.tellMeMore",
  },
  playtest: {
    id: "app.components.Home.playtest",
  },
  playtestHeader01: {
    id: "app.components.Home.playtestHeader01",
  },
  playtestDesc01: {
    id: "app.components.Home.playtestDesc01",
  },
  playtestHeader02: {
    id: "app.components.Home.playtestHeader02",
  },
  playtestDesc02: {
    id: "app.components.Home.playtestDesc02",
  },
  rewardHeader: {
    id: "app.components.Home.rewardHeader",
  },
  rewardDesc: {
    id: "app.components.Home.rewardDesc",
  },
  rewardText01: {
    id: "app.components.Home.rewardText01",
  },
  rewardText02: {
    id: "app.components.Home.rewardText02",
  },
  rewardText03: {
    id: "app.components.Home.rewardText03",
  },
  rewardFooter: {
    id: "app.components.Home.rewardFooter",
  },
  type: {
    id: "app.components.Home.type",
  },
  studioTestHeader: {
    id: "app.components.Home.studioTestHeader",
  },
  studioTestDesc: {
    id: "app.components.Home.studioTestDesc",
  },
  remoteTestHeader: {
    id: "app.components.Home.remoteTestHeader",
  },
  remoteTestDesc: {
    id: "app.components.Home.remoteTestDesc",
  },
  otherHeader: {
    id: "app.components.Home.otherHeader",
  },
  otherDesc: {
    id: "app.components.Home.otherDesc",
  },
  ubisoftMontreal: {
    id: "app.components.Home.ubisoft.Montreal",
  },
  ubisoftHalifax: {
    id: "app.components.Home.ubisoft.Halifax",
  },
})
